import React from "react";
import { ResponsiveContainer } from "recharts";

export const PALETTE = ["#b3122a", "#1f6feb", "#0ca678", "#e8a200", "#7048e8", "#e64980", "#15aabf", "#fa5252", "#5c7cfa", "#82c91e"];

export const tooltipStyle = {
  borderRadius: 12,
  border: "1px solid #e7e9f0",
  boxShadow: "0 8px 24px -8px rgba(16,24,40,.2)",
  fontSize: 13,
};

const TONES = {
  red: "bg-[#b3122a]/10 text-[#b3122a]",
  blue: "bg-[#1f6feb]/10 text-[#1f6feb]",
  green: "bg-[#0ca678]/10 text-[#0ca678]",
  amber: "bg-[#e8a200]/10 text-[#e8a200]",
  purple: "bg-[#7048e8]/10 text-[#7048e8]",
  slate: "bg-slate-100 text-slate-500",
};

export function Kpi({ icon: Icon, label, value, sub, tone = "red", delay = 0, testid, highlight, onClick }) {
  return (
    <div
      className={`rf-card rf-fade p-5 ${highlight ? "ring-1 ring-[#b3122a]/30" : ""} ${onClick ? "cursor-pointer hover:-translate-y-0.5 transition-transform" : ""}`}
      style={{ animationDelay: `${delay}ms` }}
      data-testid={testid}
      onClick={onClick}
    >
      <div className="flex items-start justify-between">
        <div className="min-w-0">
          <div className="text-sm text-slate-500 font-medium truncate">{label}</div>
          <div className="font-display text-2xl font-extrabold text-[#1a1a1b] mt-2">{value}</div>
          {sub && <div className="text-xs text-slate-400 mt-1">{sub}</div>}
        </div>
        <div className={`h-11 w-11 rounded-sm flex items-center justify-center shrink-0 ${TONES[tone]}`}>
          <Icon size={20} />
        </div>
      </div>
    </div>
  );
}

export function ChartCard({ title, subtitle, children, className = "", testid }) {
  return (
    <div className={`rf-card p-5 ${className}`} data-testid={testid}>
      <div className="mb-4">
        <h3 className="font-display font-bold text-[#1a1a1b]">{title}</h3>
        {subtitle && <p className="text-xs text-slate-400 mt-0.5">{subtitle}</p>}
      </div>
      {children}
    </div>
  );
}

export function Chart({ height = 290, children }) {
  return (
    <ResponsiveContainer width="100%" height={height}>
      {children}
    </ResponsiveContainer>
  );
}
